<ion-content class="ion-page">
  <ion-toolbar class="my-toolbar">
    <ion-title> Filtros </ion-title>
    <ion-icon
      style="font-size: 30px; padding-right: 15px"
      slot="end"
      name="close-outline"
      (click)="closeMenuEvent()"
    ></ion-icon>
  </ion-toolbar>
  <ion-list class="pb-nav" lines="none">
    <p
      *ngIf="dataService.filtersActivated()"
      style="padding-right: 15px; padding-left: 15px"
    >
      <ion-chip *ngFor="let name of dataService.getNamesWithFilters()">
        <ion-label>{{ name }}</ion-label>
        <ion-icon
          name="close-circle"
          (click)="dataService.removeFiltersByName(name)"
        ></ion-icon>
      </ion-chip>
      <ion-chip color="danger">
        <ion-label>Borrar Filtros</ion-label>
        <ion-icon
          name="close-circle"
          (click)="dataService.clearFilters()"
        ></ion-icon>
      </ion-chip>
    </p>
    <div *ngFor="let item of menuContent; index as i">
      <ion-item color="white" lines="none" (click)="collapse(i)">
        <ion-label>{{ item.name }}</ion-label>
        <ion-icon
          slot="end"
          style="font-size: 20px"
          name="{{
            dataService.collapsed == i
              ? 'chevron-up-outline'
              : 'chevron-down-outline'
          }}"
        ></ion-icon>
      </ion-item>
      <ion-item *ngIf="dataService.collapsed === i" color="contrast">
        <app-filter-calendar
          *ngIf="item.mode === 'calendar'"
          style="width: 100%"
          [filterName]="item.col"
        ></app-filter-calendar>
        <app-filter-input
          *ngIf="item.mode === 'input'"
          style="width: 100%"
          [filterName]="item.col"
        ></app-filter-input>
        <app-filter-boolean
          *ngIf="item.mode === 'boolean'"
          style="width: 100%"
          [filterName]="item.col"
        ></app-filter-boolean>
        <app-filter-number-range
          *ngIf="item.mode === 'numberRange'"
          style="width: 100%"
          [filterName]="item.col"
        ></app-filter-number-range>
      </ion-item>
    </div>
    <ion-item color="white">
      <button
        mat-raised-button
        color="primary"
        style="width: 100%; margin-top: 20px"
        (click)="sendFilters()"
      >
        <mat-icon>filter_list</mat-icon>
        Filtrar
      </button>
    </ion-item>
  </ion-list>
</ion-content>
